import {DestroyRef, inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private route = inject(ActivatedRoute);
  private destroy = inject(DestroyRef)

  public getAccessToken(): string {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith('d86c828583c5c6160e8acfee88ba1590='))
      ?.split('=')[1] ?? '';
  }

  public isAuthenticated(): boolean {
    return !!this.getAccessToken();
  }

  public refreshToken(){
    return  this.http.post(`${environment.baseUrl}/service/webapi/v1/account/refresh`, {})
  }


  public login() {
    this.http.get(
      `${environment.baseUrl}/service/webapi/v1/account/signin?requestedUrl=${window.location.href}`,
      { responseType: 'text' }
    )
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
        next: (redirectUrl) => {
          window.location.href = redirectUrl;
        },
      });
  }


  public logout(){
    this.http.post(`${environment.baseUrl}/service/webapi/v1/account/logout`, {}).pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
        next: () => {
          window.location.href = environment.portalOnfUrl
        },
        error: () => {
          window.location.href = environment.portalOnfUrl
        }
      });
    }
  }
